
import React from "react";

const AddToCartConfirmation = ({ show, productName, onClose, confirmationType }) => {
  if (!show) return null;

  const isAlreadyInCart = confirmationType === "exists";

  return (
    <div
      className="modal d-block"
      style={{
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 9999,
      }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content text-center p-5 rounded-3">
          <div className="mb-3">
            <div className="d-flex justify-content-center align-items-center mb-4">
              <svg width="100" height="100" viewBox="0 0 100 100">
                <circle
                  cx="50"
                  cy="50"
                  r="45"
                  fill="none"
                  stroke="#d4edd9"
                  strokeWidth="5"
                />
                <circle
                  cx="50"
                  cy="50"
                  r="45"
                  fill="none"
                  stroke="#7fd79b"
                  strokeWidth="5"
                  strokeDasharray="283"
                  strokeDashoffset="440"
                  style={{
                    animation: "rotateCircle 1s ease-out forwards",
                    transformOrigin: "50% 50%",
                  }}
                />
                <polyline
                  points="30,55 45,70 70,40"
                  fill="none"
                  stroke="#28a745"
                  strokeWidth="5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{
                    opacity: 0,
                    animation: "fadeCheck 0.5s ease 1s forwards",
                  }}
                />
              </svg>
            </div>
          </div>
          <h5 className="fw-bold">{productName}</h5>
          <p className="text-muted mb-4">
            {isAlreadyInCart ? "is already in your cart!" : "is added to cart!"}
          </p>
          <div className="text-end">
            <button
              className="btn btn-dark px-4 w-25 text-white"
              onClick={onClose}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddToCartConfirmation;
